import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class RouterReuseStrategy extends BaseRouteReuseStrategy {
    /**
     * This override of default Angular Reuse Strategy allow us to force reloading component when displayed with the lateralMenu
     * Otherwise component are reused if you navigate from facture of contract 1 to facture of contract 2 and ngoninit is not recalled.
     */
    public override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return (
            future.routeConfig === curr.routeConfig &&
            future.data.lateralMenu !== true &&
            future.data.carrousel !== true
        );
    }
}
